import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class RegistrationService {

    //more about regex: https://uibakery.io/regex-library/

    private readonly notEmpty = /.+/

    //RFC 5322 Standard compliant regex
    private readonly emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+))/;

    private readonly phoneNumberRegex = /^\+?[1-9][0-9]{7,14}$/

    private readonly passwordLength = /.{14,}/
    private readonly passwordUppercase = /(?=.*?[A-Z])/
    private readonly passwordLowercase = /(?=.*?[a-z])/
    private readonly passwordNumber = /(?=.*?[0-9])/
    private readonly passwordSpecial = /(?=.*?[#?!@$%^&*-])/

    public validateEmail(email: string): boolean {
        return this.emailRegex.test(email.trim());
    }

    public validatePhoneNumber(phoneNumber: string): boolean {
        return this.phoneNumberRegex.test(phoneNumber);
    }

    public validatePassword(password: string){
        return this.passwordLength.test(password) && this.notEmpty.test(password);
    }

    public passwordStrength(password: string): number {

        return [
            this.passwordLength,
            this.passwordUppercase,
            this.passwordLowercase,
            this.passwordNumber,
            this.passwordSpecial
        ].reduce( ( strength , regex ) => {
            return strength + ( regex.test(password) ? 1 : 0 );
        }, 0 );

    }

}